import React from 'react';
import { PageProps } from '../components/component-switcher';
import PageHeader from '../components/page-header';

class Home extends React.Component<PageProps> {
    pageBodyRef: React.RefObject<any> = React.createRef();

    render() {
        let className = `home ${this.props.title.toLowerCase()}`;

        return (
            <div className={className}>
                <PageHeader pageBodyRef={this.pageBodyRef} {...this.props} />
            </div>
        );
    }
}
  
  export default Home;
  